import { ConfirmDialog } from 'components/common'

interface IProps {
  open: boolean
  stopLabels: Array<string>
  onConfirm: () => void
  onCancel: () => void
}

// Shown on Save when one or more stops have no consignment in Package Details. Saving is
// allowed; the user just has to confirm they want to go ahead.
const UnrepresentedStopsSaveConfirmation = (props: IProps) => {
  const { open, stopLabels, onConfirm, onCancel } = props

  const message = `The following stops are not represented in Package Details and their contacts will not receive Booking Tracking links: ${stopLabels.join(
    ', ',
  )}. Do you want to save anyway?`

  return (
    <ConfirmDialog
      open={open}
      setOpen={(isOpen: boolean) => {
        if (!isOpen) {
          onCancel()
        }
      }}
      onConfirm={onConfirm}
      title='Confirmation'
      message={message}
      option1='No'
      option2='Yes'
    />
  )
}

export default UnrepresentedStopsSaveConfirmation
